import { Modal } from 'components/Modal';
import styles from './ModalComment.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { useState } from 'react';
import { Textarea } from '@mantine/core';
import { ReactComponent as IconCheck } from './img/iconCheck2.svg';

export const ModalComment = ({
  setShowCommentModal,
  onConfirm,
  currentComment,
  title = 'Комментарий',
  maxLength = undefined,
}: {
  setShowCommentModal: (e: boolean) => void;
  onConfirm: (comment: string) => void;
  currentComment: string;
  title?: string;
  maxLength?: number;
}) => {
  const [comment, setComment] = useState(currentComment);
  const [error, setError] = useState(false);

  return (
    <Modal setOpen={setShowCommentModal}>
      <div className={styles.root}>
        <Title className={styles.root_title} title={title} />
        <Textarea
          placeholder='Здесь можно написать комментарий'
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          withErrorStyles={false}
          autosize
          minRows={1}
          maxRows={4}
          maxLength={maxLength}
          styles={{
            input: {
              fontSize: '16px',
              lineHeight: '24px',
              padding: '12px 12px',
              border: `${error ? '1px solid #e10d0d' : 'none'}`,
            },
            error: { fontSize: '14px', color: '#e10d0d' },
          }}
        />
        <div className={styles.root_btn}>
          <Button
            theme='outline'
            onClick={() => setShowCommentModal(false)}
            className={styles.root_btn_cancel}>
            Отмена
          </Button>
          <Button
            onClick={() => {
              if (!comment.trim()) {
                setError(true);
                return;
              }
              onConfirm(comment);
              setShowCommentModal(false);
            }}
            className={styles.root_btn_confirm}
            theme='filed'>
            <div>
              Сохранить <IconCheck />
            </div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
